module.exports = __webpack_public_path__ + "media/אמר.abc5b842.mp3";